import { StyleSheet, Dimensions } from 'react-native'
import theme from '../../../../theme'

const deviceWidth = Dimensions.get('window').width

const styles = StyleSheet.create({
    input: {
        fontSize: 15,
        width: deviceWidth - 30,
        height: 40,
        marginTop: 0,
        marginBottom: 5,
        marginHorizontal: 15,
        borderWidth: StyleSheet.hairlineWidth,
        borderRadius: 5,
        borderColor: theme.colors.lightGray,
        padding: 10,
        color: theme.colors.textPrimary,
    },
    image: {
        marginLeft: 10,
        width: 80,
        height: 80,
    },
    title: {
        fontSize: 15,
        color: theme.colors.textPrimary,
        fontWeight: 'bold',
        textAlign: 'left',
        paddingHorizontal: 15,
        paddingTop: 5,
        paddingBottom: 8,
    },
    dividerHorizontalLine: {
        width: '100%',
        borderBottomWidth: 0.5,
        borderBottomColor: theme.colors.lightGray,
        marginVertical: 10,
    },
    flexDirectionRow: {
        flexDirection: 'row',
    },
    opacity: {
        opacity: 0.5,
    },
})

export default styles
